// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-status--item {
  width: 220px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.task-status--item .data-table-dropdown {
  padding: 0 !important;
  width: 100%;
}

.task-status .user-card__input-short {
  width: 132px !important;
}

.task-status .user-card__input-short input {
  width: inherit;
}

.task-status .input-valid {
  border: 1px solid rgba(0, 128, 0, 0.45);
}

.task-status .input-invalid {
  border: 1px solid rgba(233, 129, 129, 0.72);
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/TaskStatusComponent.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;AAC7C","sourcesContent":[".task-status--item {\n  width: 220px !important;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.task-status--item .data-table-dropdown {\n  padding: 0 !important;\n  width: 100%;\n}\n\n.task-status .user-card__input-short {\n  width: 132px !important;\n}\n\n.task-status .user-card__input-short input {\n  width: inherit;\n}\n\n.task-status .input-valid {\n  border: 1px solid rgba(0, 128, 0, 0.45);\n}\n\n.task-status .input-invalid {\n  border: 1px solid rgba(233, 129, 129, 0.72);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
